import { render, staticRenderFns } from "./BoardMembersManager.vue?vue&type=template&id=cdd3709c&scoped=true"
import script from "./BoardMembersManager.vue?vue&type=script&lang=js"
export * from "./BoardMembersManager.vue?vue&type=script&lang=js"
import style0 from "./BoardMembersManager.vue?vue&type=style&index=0&id=cdd3709c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd3709c",
  null
  
)

export default component.exports